import { render, staticRenderFns } from "./EmployeeSectorAddEdit.vue?vue&type=template&id=71e32c21"
import script from "./EmployeeSectorAddEdit.vue?vue&type=script&lang=js"
export * from "./EmployeeSectorAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports